import { render, staticRenderFns } from "./yygj.vue?vue&type=template&id=5a8ce432&scoped=true"
import script from "./yygj.vue?vue&type=script&lang=js"
export * from "./yygj.vue?vue&type=script&lang=js"
import style0 from "./yygj.vue?vue&type=style&index=0&id=5a8ce432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ce432",
  null
  
)

export default component.exports